import React from 'react';
import { useComposites } from '../hooks/useComposites.ts';
import { useSurchargeLookup } from '../hooks/useSurchargeLookup.ts';
import { Spinner } from '../components/ui/spinner.tsx';
import CompositeCard from '../components/CompositeCard.tsx';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button.tsx';
import { useWhitelabelContext } from '../context/WhitelabelContext.tsx';

const MyCompositesTab: React.FC = () => {
  const { composites, loading, error, fetchComposites } = useComposites();
  const { surcharges, loading: surchargesLoading, error: surchargesError } = useSurchargeLookup();

  const { whitelabelConfig } = useWhitelabelContext();

  const getEntityTitle = (defaultTitle: string, singular: boolean) => 
    (singular && whitelabelConfig.entities?.['composites'].title_singular) || whitelabelConfig.entities?.['composites'].title || defaultTitle;

  if (loading || surchargesLoading) {
    return (
      <div className="flex justify-center items-center h-64">
        <Spinner size="lg" />
        <p className="ml-2 text-muted-foreground">Loading {getEntityTitle('composite products')}...</p>
      </div>
    );
  }

  if (composites.length === 0) {
    return (
      <div className="p-4 text-center text-muted-foreground">
        <h2 className="text-2xl font-semibold mb-4">Welcome to Ultimate COGS Calculator!</h2>
        <p className="mb-4">No {getEntityTitle('composite products')} found. Start by creating one!</p>
        <Button asChild>
          <Link to="/composites">Go to {getEntityTitle('Composites')} Page</Link>
        </Button>
      </div>
    );
  }

  return (
    <div className="p-4">
      
      <h2 className="text-3xl font-bold mb-6 text-center text-secondary-foreground">Your {getEntityTitle('Composite Products')}</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {composites.map((composite) => (
          <CompositeCard key={composite.id} composite={composite} surcharges={surcharges} />
        ))}
      </div>
    </div>
  );
};

export default MyCompositesTab;
